type SectionHeadProps = {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "center" | "left";
};

export default function SectionHead({
  eyebrow,
  title,
  desc,
  align = "center",
}: SectionHeadProps) {
  const alignCls = align === "center" ? "mx-auto text-center" : "text-left";
  const flexCls = align === "center" ? "justify-center" : "justify-start";
  return (
    <div className={`max-w-2xl ${alignCls}`}>
      <div className={`flex items-center gap-2 ${flexCls}`}>
        <span className="h-px w-6 bg-rose-400" aria-hidden="true" />
        <span className="text-xs font-semibold uppercase tracking-[0.2em] text-rose-500">
          {eyebrow}
        </span>
        <span className="h-px w-6 bg-rose-400" aria-hidden="true" />
      </div>
      <h2 className="mt-3 font-heading text-3xl text-stone-800 md:text-4xl">{title}</h2>
      {desc && (
        <p className="mt-4 text-base leading-relaxed text-stone-500">{desc}</p>
      )}
    </div>
  );
}